export default "/images/next.svg"